import { Feature } from "@types"
import { FEATURE } from "@constants"

export const hasFeature = (featureList: Feature[], featureId: string) => {
  return Boolean(featureList?.find(feature => feature.feature_id === featureId))
}